import { CircleNotch, PencilSimple } from "@phosphor-icons/react";
import cx from "classnames";

interface ListItemRenameButtonProps {
  ariaLabel: string;
  "data-testid": string;
  onClick: () => void;
  isPending?: boolean;
}

/**
 * Owner-only rename control for Ask Puntt chats/projects list cards (and list
 * rows). Companion to {@link ListItemDeleteButton}: circular, hover-revealed,
 * rests as a black pencil and soft-fills gray on control hover (delete keeps
 * the red destructive treatment).
 */
export function ListItemRenameButton({
  ariaLabel,
  "data-testid": testId,
  onClick,
  isPending = false,
}: ListItemRenameButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      data-testid={testId}
      disabled={isPending}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      className={cx(
        "flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full",
        "text-puntt-neutral-gray-12 opacity-0 transition-colors",
        "hover:bg-puntt-neutral-gray-4",
        "focus-visible:opacity-100 group-hover:opacity-100",
        "disabled:cursor-wait",
      )}
    >
      {isPending ? (
        <CircleNotch size={14} className="animate-spin" aria-hidden="true" />
      ) : (
        <PencilSimple size={14} aria-hidden="true" />
      )}
    </button>
  );
}
